import { useState, useEffect } from "react";

const WrappedBadge = () => {
  const [badgeUrl, setBadgeUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const raw = localStorage.getItem("authUser");
      if (!raw) {
        setError("No user session found. Please log in.");
        return;
      }

      // authUser may be stored as a JSON string or a plain string
      let email = "";
      try {
        const parsed = JSON.parse(raw);
        email = parsed?.EmailAddress || "";
      } catch {
        // If it's not valid JSON, try to extract email from raw string
        const match = raw.match(/"EmailAddress"\s*:\s*"([^"]+)"/);
        email = match ? match[1] : "";
      }

      if (!email) {
        setError("Email not found in user session.");
        return;
      }

      const url = `https://html-websites-572989304736.asia-south1.run.app/wrapped.html?email=${encodeURIComponent(email)}`;
      setBadgeUrl(url);
    } catch (err) {
      setError("Failed to load badge. Please try again.");
    }
  }, []);

  return (
    <div style={styles.wrapper}>
      {error ? (
        <div style={styles.errorContainer}>
          <div style={styles.errorIcon}>⚠</div>
          <p style={styles.errorText}>{error}</p>
        </div>
      ) : badgeUrl ? (
        <iframe
          src={badgeUrl}
          title="User Badge"
          style={styles.iframe}
          frameBorder="0"
          allowFullScreen
        />
      ) : (
        <div style={styles.loadingContainer}>
          <div style={styles.spinner} />
          <p style={styles.loadingText}>Loading badge...</p>
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    color: "#fff",
    fontFamily: "sans-serif",
  },
  errorIcon: {
    fontSize: "48px",
  },
  errorText: {
    fontSize: "16px",
    opacity: 0.8,
    textAlign: "center",
    maxWidth: "320px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    color: "#fff",
    fontFamily: "sans-serif",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "3px solid rgba(255,255,255,0.2)",
    borderTop: "3px solid #fff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  loadingText: {
    fontSize: "14px",
    opacity: 0.6,
  },
};

// Inject keyframe for spinner
const styleTag = document.createElement("style");
styleTag.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
document.head.appendChild(styleTag);

export default WrappedBadge;